export const BASE_RATE_FORM = 'BASE_RATE_FORM';
export const SELECT_TIME_FORM = 'SELECT_TIME_FORM';
export const DISCOUNT_RATE_FORM = 'DISCOUNT_RATE_FORM';
export const CLEANING_FEE_FORM = 'CLEANING_FEE_FORM';
export const FANDB_FORM = 'FANDB_FORM';
export const VARIABLE_PRICING_FORM = 'VARIABLE_PRICING_FORM';
export const ATTENDEE_PRICING_FORM = 'ATTENDEE_PRICING_FORM';
